import React from 'react'

import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const Icon60FirewallDone = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 40 48'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M39.998,17.866 C40.000,18.225 39.907,41.045 20.332,47.942 C20.327,47.944 20.321,47.943 20.315,47.945 C20.214,47.979 20.108,47.999 20.000,47.999 C19.892,47.999 19.786,47.979 19.685,47.945 C19.679,47.943 19.673,47.944 19.667,47.942 C0.097,41.045 0.000,18.225 0.002,17.866 C0.002,17.866 0.002,17.866 0.002,17.866 L0.002,7.999 C0.002,6.897 0.899,5.998 2.002,5.998 L5.654,5.998 C5.662,5.998 5.669,6.003 5.678,6.003 C5.687,6.003 5.694,5.998 5.703,5.998 C15.430,5.998 19.075,0.513 19.110,0.458 C19.294,0.172 19.611,-0.001 19.951,-0.001 C20.294,-0.001 20.708,0.167 20.891,0.457 C21.037,0.680 24.643,5.998 34.297,5.998 C34.307,5.998 34.314,6.004 34.324,6.004 C34.333,6.004 34.341,5.998 34.350,5.998 L37.998,5.998 C39.101,5.998 39.998,6.897 39.998,7.999 L39.998,17.866 C39.998,17.866 39.998,17.866 39.998,17.866 ZM37.998,17.866 L37.998,7.999 L34.350,7.999 C34.341,7.999 34.333,7.994 34.324,7.994 C34.314,7.994 34.307,7.999 34.297,7.999 C26.003,7.999 21.652,4.348 20.001,2.533 C18.351,4.348 14.000,7.999 5.703,7.999 C5.694,7.999 5.687,7.995 5.678,7.994 C5.669,7.995 5.662,7.999 5.654,7.999 L2.002,7.999 L2.002,17.866 C2.002,17.867 2.001,17.868 2.001,17.870 C2.001,17.871 2.002,17.873 2.002,17.874 C2.000,18.090 2.075,39.343 20.000,45.926 C37.958,39.333 38.000,18.090 37.998,17.874 C37.998,17.873 37.999,17.871 37.999,17.870 C37.999,17.868 37.998,17.867 37.998,17.866 ZM19.967,30.592 C19.804,30.814 19.555,30.959 19.281,30.993 C19.241,30.997 19.202,30.999 19.162,30.999 C18.929,30.999 18.701,30.917 18.520,30.766 L11.359,24.766 C10.935,24.411 10.880,23.780 11.234,23.357 C11.589,22.934 12.219,22.876 12.643,23.233 L18.988,28.549 L27.194,17.406 C27.521,16.962 28.148,16.867 28.592,17.193 C29.037,17.522 29.132,18.147 28.804,18.592 L19.967,30.592 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

Icon60FirewallDone.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
